import { useFetchAssetProductIxOneCert } from 'pages/home/ribbon/components/controls/asset/hook';

export const useCheckShowIxOneWarning = () => {
  const fetchAssetProductIxOneCert = useFetchAssetProductIxOneCert();

  const isLoading = fetchAssetProductIxOneCert.isLoading;

  const showConfirmIxOneModal = async ({
    showModal,
    handleConfirmIXONE,
    assetIds,
  }) => {
    try {
      const response = await fetchAssetProductIxOneCert.mutateAsync({
        assetIds: assetIds,
      });
      const shouldShowConfirmModal =
        showModal && response?.products?.length > 0;
      handleConfirmIXONE({
        otherInformation: {
          condition: shouldShowConfirmModal,
          list: response?.products,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  return { showConfirmIxOneModal, isLoading };
};
